module.exports = __webpack_public_path__ + "media/img/use-ico-7-b4b3af0185fe3a6ed467560d447ec008.svg";